import { createBasicSelector } from 'util/redux'
import { selectMailboxByStates } from './selectMailboxByStates'

export const selectHasAnyMailboxByStates = createBasicSelector(
  selectMailboxByStates,
  mailboxByStates => {
    return mailboxByStates.length > 0
  }
)
